import type { DocumentCaptureStepValues } from '@/steps/document/constants';

import { DocumentReview } from './review';

import { Processing } from '@/components/Processing/Processing';
import { DocumentCaptureStep } from '@/steps/document/constants';
import * as GSC from '@/styles/GlobalStyles';

export type DocumentInfoOverlayProps = {
  captureStep: DocumentCaptureStepValues;
  continueToSecondPage?: () => void;
  image: Blob | null;
  skipSecondPage?: () => void;
};

export const DocumentInfoOverlay = ({
  captureStep,
  continueToSecondPage,
  image,
  skipSecondPage,
}: DocumentInfoOverlayProps) => {
  switch (captureStep) {
    case DocumentCaptureStep.REVIEW:
      return (
        <GSC.FadeInContainer>
          <DocumentReview capturedImage={image} onContinue={continueToSecondPage} onSkip={skipSecondPage} />
        </GSC.FadeInContainer>
      );

    case DocumentCaptureStep.PROCESSING:
      return (
        <GSC.FadeInContainer>
          <Processing capturedImage={image} />
        </GSC.FadeInContainer>
      );

    default:
      return null;
  }
};
